import React, { createContext, useState, useMemo, useContext, useCallback } from 'react';
import { pointMappingService } from '../services/PointMappingService';

export const PointMappingContext = createContext();

export const PointMappingProvider = props => {
    const [pointMapping] = useState([]);
    const [equipmentPoints, setEquipmentPoints] = useState([]);

    const viewEquipmentPoints = useCallback(async (buildingId, equipmentId) => {
        const result = await pointMappingService.viewEquipmentPoints(buildingId, equipmentId);
        setEquipmentPoints(result);
        return result;
    }, []);

    const values = useMemo(
        () => ({
            equipmentPoints,
            setEquipmentPoints,
            pointMapping,
            viewEquipmentPoints,
        }),
        [
            equipmentPoints,
            setEquipmentPoints,
            pointMapping,
            viewEquipmentPoints,
        ]
    );

    return <PointMappingContext.Provider value={values}>{props.children}</PointMappingContext.Provider>;
};

export const usePointMapping = () => {

    const context = useContext(PointMappingContext);

    if (context === undefined) {
        throw new Error('usePointMapping must be used within a PointMappingProvider component.');
    }

    return context;
};
